<div class="card">
  <h2 class="documentation-title">Validación de identidad</h2>
  <p class="documentation-subtitle">
    Necesitamos validar su identidad, por favor, suba una foto selfie con DNI en mano, junto con un
    cartel que indique la fecha actual, y la siguiente leyenda "Quiero operar en Tienda Crypto"
  </p>

  <img
    *ngIf="!fundOriginSent"
    class="instructions"
    src="assets/images/selfie-instructions.png"
    alt="Instrucciones para tomarse la selfie para validación de identidad"
  />

  <button *ngIf="!fundOriginSent" (click)="openUploadImageWindow()" class="td-btn primary">
    Subir
  </button>

  <p *ngIf="fundOriginSent" class="sended-image">
    La imagen fue subida exitosamente. Esperá a ser validado.
  </p>
</div>
